import React from "react";
import { parcelHandoffKey, readParcelHandoff } from "../../../utils/parcelHandoff";

/**
 * The owner a property coming from the parcel map will get, before it exists.
 *
 * The tab below this one reads ownership rows out of the database and writes
 * every change straight back, so it has nothing to show and nothing to edit
 * until the property has been saved once. This says what the save will do and
 * where to change it.
 *
 * It follows the map: changing the owner over there rewrites the payload, and
 * the browser tells this tab about it, so what is shown here is what will be
 * saved rather than what was chosen when the tab opened.
 */
const PendingOwnerNotice = ({ owner, token }) => {
    const [current, setCurrent] = React.useState(owner);

    React.useEffect(() => {
        if (!token) return undefined;

        const key = parcelHandoffKey(token);
        const onStorage = (event) => {
            if (event.key !== key) return;

            const handoff = readParcelHandoff(token);

            if (handoff) setCurrent(handoff.owner);
        };

        window.addEventListener('storage', onStorage);

        return () => window.removeEventListener('storage', onStorage);
    }, [token]);

    return (
        <div className="Owners-info" style={{ padding: '24px', backgroundColor: '#fafbfc' }}>
            <div style={{
                padding: '20px 22px',
                backgroundColor: '#fff',
                border: '1px solid #e3e6ea',
                borderRadius: '8px',
                maxWidth: '640px',
            }}>
                <div style={{ fontSize: '13px', fontWeight: 500, letterSpacing: '0.06em', color: '#5f6368', marginBottom: '10px' }}>
                    OWNER ON SAVE
                </div>
                <div style={{ fontSize: '16px', color: '#202124', marginBottom: '4px' }}>
                    {(current && current.label) || 'No investor will be attached.'}
                </div>
                {current && current.sub && (
                    <div style={{ fontSize: '13px', color: '#5f6368' }}>{current.sub}</div>
                )}
                <div style={{ marginTop: '16px', fontSize: '13px', color: '#5f6368', lineHeight: 1.6 }}>
                    This property has not been added yet, so there is nothing to edit here.
                    To choose a different owner, change it on the parcel panel — this tab
                    follows along — or press Add to create the property first, then edit the
                    owner on this tab.
                </div>
            </div>
        </div>
    );
};

export default PendingOwnerNotice;
